
import { onMounted, reactive, computed , ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment'
import { isAndroid, isIOS } from '@/utils/utils'
import { reloadPageApi, sendMessageToFlutter } from '@/api/api'

export default {
    name: "ErrorExternalLinks",
    components: {
    },
    setup() {
        const store = useStore()
        const local = computed(() => store.state.translation.locale)
        const router = useRouter()
        const route = useRoute()
        const title_ = ref()
        const isEN = computed(() => route.query.lang?.toString().toLowerCase() == 'en')
        const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })
        const data = reactive({
            encryptedToken: decodeURIComponent(route.query.id as any ?? ' ').replace(/\s/g, '+'),
        })

       onMounted(async ()=>{
        await store.dispatch(`translation/getLangs`, { userLang: route.query.lang??'cn' })
        title_.value = route.query.title ?? local.value.share_error
       })

        

        const BackToMain = () => {
            sendMessageToFlutter('clickBack')
        }

        const reloadPage = () => {
            const external_links_v = route.query.external_links || '1'
            reloadPageApi('reloadPage')
            let path__ = '/ads-functions'
            if(external_links_v === '1') {
                path__ = '/ads-functions'
            } else {
                path__ = '/ads-functions2'
            }
            router.push({
                path:path__,
                query: { lang: route.query.lang ?? 'cn' }
            })
            
        }
        

        const convertDate = (date) => {
            return moment(date).format("YYYY-MM-DD HH:mm")
        }

        return {
            data,
            local,
            BackToMain,
            convertDate,
            isEN,
            getAgentType,
            reloadPage,
            title_,
        }
    }
}

